import {useContext} from 'react';
import GlobalContext, {GlobalContextProps} from '@/contexts/globalsContext';

const useGlobalContext = (): GlobalContextProps => {
  const context = useContext(GlobalContext);

  if (!context) {
    throw new Error(
      'useGlobalContext must be used within an GlobalContextProvider',
    );
  }

  return context;
};

export default useGlobalContext;
